'use strict';
define(['xhr-promise', './../util', './../analytics', '../../../../lib/domQ'], function (XhrPromise, util, analytics, domQ) {

    var MENU_ID_PART = '_menu';
    var HAMBURGER_MENU_TOP_HEIGHT = 207;
    var NON_FESK_MENU_TOP_HEIGHT = 6;
    var PANE_TWO_IPAD_BOTTOM = 9;
    var DOCK_POS_NOL23 = 90;
    var MOBILE_BREAKPOINT = 320;
    var TABLET_BREAKPOINT = 768;

    function Level3(config) {
        this.config = config;
        this.navContainerEl = document.getElementById('navContainer');
    }

    Level3.prototype.attachToDom = function (html) {
        this.navContainerEl.children[2].innerHTML = html;
    };
    Level3.prototype.loadStatic = function () {
        var _this = this;
        var NavL23Data = 'NavL23DataUK';
        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
            NavL23Data = 'NavL23DataIE';
        }
        _this.attachToDom(window.localStorage[NavL23Data]);
        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
        _this.hideAllPanels();
        _this.analytics();
    };
    Level3.prototype.load = function () {
        var _this = this;
        var NavL23Data = 'NavL23DataUK';
        var NavL23Date = 'NavL23DateUK';
        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
            NavL23Data = 'NavL23DataIE';
            NavL23Date = 'NavL23DateIE';
        }
        if (window && window.MS_COMMON_L23CMDCALL) {
            var xhrp = new XhrPromise();
            var host = this.config.wcsBaseUrl + this.config.CMD.navigation23;
            var params = {
                storeId: this.config.storeId,
                langId: this.config.langId
            };

            return xhrp.send({
                url: util.constructUrl(host, params),
                method: 'GET'
            }).then(function (response) {
                if (response.status === 200) {
                    if (response.responseText.indexOf('Generic Error Page') === -1 && response.responseText.indexOf('500 Internal Server Error') === -1 && response.responseText !== '' && response.responseText.indexOf('Sorry, something went wrong') === -1) {
                        window.localStorage[NavL23Data] = response.responseText;
                        window.localStorage[NavL23Date] = new Date();
                        _this.attachToDom(response.responseText);
                        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
                        _this.hideAllPanels();
                        _this.analytics();
                    } else if (window.localStorage[NavL23Data]) {
                        _this.attachToDom(window.localStorage[NavL23Data]);
                        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
                        _this.hideAllPanels();
                        _this.analytics();
                    }
                }
            });
        }
        else if (!window.MS_COMMON_L23CMDCALL) {
            this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
            this.hideAllPanels();
            this.analytics();
        }
    };
    Level3.prototype.analytics = function () {
        var analyticActions = [{
            functionName: 'analyticsTopNav',
            event: 'click'
        }];
        analytics.bind(document.querySelectorAll('.navigation-primary a'), analyticActions);
    };
    Level3.prototype.dockNavBottom = function (el) {
        if (window.innerHeight < MOBILE_BREAKPOINT) {  // bottom value adjustments iPhone devices with height<320
            el.style.bottom = (window.innerHeight - MOBILE_BREAKPOINT) + 'px';
        }
        else if (window.innerWidth === TABLET_BREAKPOINT) { // bottom value adjustments for iPadmini
            el.style.bottom = -(window.innerHeight - HAMBURGER_MENU_TOP_HEIGHT - PANE_TWO_IPAD_BOTTOM) + 'px';
        }
        else if (window.innerHeight > MOBILE_BREAKPOINT) {
            el.style.bottom = -(window.innerHeight - HAMBURGER_MENU_TOP_HEIGHT + NON_FESK_MENU_TOP_HEIGHT) + 'px';
        }
    };
    Level3.prototype.showPanel = function (id) {
        var panel = document.getElementById(id);
        let el = document.querySelector('.navigation-pane-two-navbottom');
        if (panel) {
            panel.style.display = 'block';
            panel.setAttribute('aria-hidden', false);
            panel.classList.add('navigation-open-submenu');
            if (el) {
                this.dockNavBottom(el);
                if (domQ(el).hasClass('navigation-dock-pos')) {
                    domQ(el).removeClass('navigation-dock-pos');
                }
            }
        } else {
            if (el) {
                domQ(el).addClass('navigation-dock-div');
                el.style.top = (window.innerHeight - DOCK_POS_NOL23) + 'px';
                if (!domQ(el).hasClass('navigation-dock-pos')) {
                    domQ(el).addClass('navigation-dock-pos');
                }
            }
        }
    };
    Level3.prototype.hideAllPanels = function () {
        var subMenuEl = this.navPrimarySubmenuList;
        if (subMenuEl) {
            for (var iSubItem = 0; iSubItem < subMenuEl.length; iSubItem++) {
                if (!subMenuEl[iSubItem].classList.contains('navigation-bottom-container')) {
                    subMenuEl[iSubItem].style.display = 'none';
                    subMenuEl[iSubItem].setAttribute('aria-hidden', true);
                }
                if (subMenuEl[iSubItem].classList.contains('navigation-open-submenu')) {
                    subMenuEl[iSubItem].classList.remove('navigation-open-submenu');
                }
            }
        }
    };
    Level3.prototype.getPanelId = function (menuid) {
        return menuid.replace(MENU_ID_PART, '');
    };
    return Level3;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/Level3.js